"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../../../../../chunks/clsx-CBkIpawf.js");
const label = "_label_hdz8e_1";
const styles = {
  label,
  "label-error": "_label-error_hdz8e_12",
  "label-required": "_label-required_hdz8e_16"
};
const Label = ({
  children,
  isError,
  isRequired,
  className,
  optionalLabelText,
  ...props
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(
    "label",
    {
      ...props,
      className: clsx.clsx(
        styles.label,
        className,
        isError && styles["label-error"],
        isRequired && styles["label-required"]
      ),
      children: [
        children,
        !isRequired && optionalLabelText && ` (${optionalLabelText})`
      ]
    }
  );
};
exports.Label = Label;
